module.exports = __webpack_public_path__ + "img/logo.99af3ea6.png";